import { NgModule } from '@angular/core';

import { TranslatePipe } from './translate/translate.pipe';
import { IbexDatePipe } from './ibex-date/ibex-date.pipe';
import { RoundPipe } from './round/round.pipe';
import { FormatTeaserPipe } from './formatTeaser/formatTeaser.pipe';

@NgModule({
  declarations: [
    TranslatePipe,
    IbexDatePipe,
    RoundPipe,
    FormatTeaserPipe
  ],
  exports: [
    TranslatePipe,
    IbexDatePipe,
    RoundPipe,
    FormatTeaserPipe
  ]
})
export class PipesModule {
}
